import apiService from 'services/api.service'
import store from 'store'

export default {

    async getRegions() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getRegionsForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getSpoPriceReport(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'reports/getSpoPriceReport',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response);
            }).catch((error) => {
                reject(error)
            })
        })
    }
}
